import { useContext, useState } from 'react';
import { Modal, SystemFeaturesContext, Tooltip } from '@/components';
import classNames from 'classnames';
import XLight from '@/assets/xLight.svg';
import FilePdfLight from '@/assets/filePdfLight.svg';
import CopySimpleLight from '@/assets/copy-simple-light.svg';
import { LinkModel } from '@/types';

type PDFLinkButtonModel = {
  pdfLink: LinkModel;
  className?: string;
  tooltipPlacement?: 'top' | 'bottom' | 'left' | 'right';
};

const PDFLinkButton = ({ pdfLink, className, tooltipPlacement = 'top' }: PDFLinkButtonModel) => {
  const [open, setOpen] = useState(false);
  const { realHost } = useContext(SystemFeaturesContext);

  const closeModal = () => {
    setOpen(false);
  };

  const pdfLinkUrl = pdfLink.href.startsWith('/') ? realHost + pdfLink.href : pdfLink.href;

  const copyValueToClipboard = async (value: string) => {
    try {
      // Check for Clipboard API support
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(value);
      }
    } catch (err) {
      console.error('Failed to copy the link: ', err);
    }
  };

  return (
    <>
      <Tooltip placement={tooltipPlacement} content="PDF Link">
        <button
          className={classNames('rounded-full p-2 hover:bg-gray-100', className, 'cursor-pointer')}
          onClick={() => {
            setOpen(true);
          }}
        >
          <FilePdfLight className="h-7 w-7" />
        </button>
      </Tooltip>
      <Modal
        open={open}
        onClose={closeModal}
        contanerClassName="w-auto h-auto bg-white !rounded-none lg:!rounded-md disable-scroll"
      >
        <div className="flex w-[500px] flex-col gap-4 px-6 py-4">
          <div className="flex flex-row items-center justify-between gap-3">
            <div className="text-xl leading-8 tracking-[0.25px]">PDF Link</div>
            <button className="btn icon" onClick={closeModal}>
              <XLight className="h-7 w-7" />
            </button>
          </div>
          <div className="flex flex-col pb-4">
            <div className="flex flex-row items-center justify-between gap-2">
              <input
                type="text"
                readOnly
                value={pdfLinkUrl}
                className="h-8 w-10/12 overflow-hidden border-b bg-transparent p-0 break-all focus:ring-0"
              />

              <div className="w-2/12 text-right">
                <button className="btn icon" onClick={() => copyValueToClipboard(pdfLinkUrl)}>
                  <CopySimpleLight className="h-7 w-7" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default PDFLinkButton;
